export const MEMBERS_PER_PAGE = 18;
export const DEFAULT_SORT = 'default';
export const PUBLIC_PRIVACY_STATUS = 'public';
export const DEFAULT_FILTER = 'all';

export const BLOG_POSTS_PER_PAGE = 9;
